'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = require('react-transition-group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _props = this.props,
        children = _props.children,
        minSize = _props.minSize,
        timeout = _props.timeout,
        childFactory = _props.childFactory,
        content = null;

    // в зависимости от того, передана ли минимальная высота элемента, рендерится:
    // CSSTransition c children, и убирается из DOM после окончания анимации закрытия
    // просто children и остаются в DOM после окончания анимации, для показа части children соответствующей minHeight

    if (minSize) {
        content = children;
    } else {
        content = _react.Children.map(children, function (child) {
            return _react2.default.createElement(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: '',
                    component: null,
                    timeout: timeout,
                    appear: true,
                    enter: true,
                    exit: true
                },
                _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    child
                )
            );
        });
    }

    return _react2.default.createElement(
        'div',
        {
            style: this.getWrapperStyles(),
            onTransitionEnd: this.handleTransitionEnd,
            ref: this.setContentRef
        },
        _react2.default.createElement(
            _reactTransitionGroup.TransitionGroup,
            {
                component: null,
                childFactory: childFactory
            },
            content
        )
    );
};